import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { useScreenSize } from "shared/lib/useScreenSize"
import { ButtonProps } from "shared/ui/buttons/Button"

import { useProductConfiguratorContext } from "widgets/product-configurator/model/ProductConfiguratorContext"

import { ProductConfigurationOverlayProps } from "../ProductConfigurationOverlay"
import { ProductConfigurationOverlayViewModel } from "../ProductConfigurationOverlayView"

export function useProductConfigurationOverlayViewModel({
  title,
  productType,
  productConfiguratorModel,
  ...rest
}: ProductConfigurationOverlayProps): ProductConfigurationOverlayViewModel {
  const { t } = useTranslation()
  const { isMobile } = useScreenSize()
  const isSubmitDisabled =
    productConfiguratorModel?.isLoading ||
    productConfiguratorModel?.isDisabled ||
    !productConfiguratorModel.hasError

  const headline = `${t("Product.Configuration.Configuration")} ${
    isMobile ? productType : title || productType
  }`

  const {
    activeStep,
    firstStep,
    isPreviousStepDisabled,
    activatePreviousStep
  } = useProductConfiguratorContext()

  const previousButtonProps = useMemo<ButtonProps>(
    () => ({
      disabled: isPreviousStepDisabled,
      isHidden: activeStep === firstStep,
      onClick: activatePreviousStep
    }),
    [isPreviousStepDisabled, activeStep, firstStep, activatePreviousStep]
  )

  return {
    ...rest,
    headline,
    productConfiguratorModel,
    isSubmitDisabled,
    scrollOnTabChange: isMobile,
    previousButtonProps
  }
}
